import React from "react";
import { Link } from "react-router-dom";

const ComponentGovernanceChrono = (props) => {
  const { objets, temporalite } = props;

  const itemsHebdomadaire = [
    { title: "Lu.", titleBig: "Lundi" },
    { title: "Ma.", titleBig: "Mardi" },
    { title: "Me.", titleBig: "Mercredi" },
    { title: "Je.", titleBig: "Jeudi" },
    { title: "Ve.", titleBig: "Vendredi" },
    { title: "Sa.", titleBig: "Samedi" },
    { title: "Di.", titleBig: "Dimanche" },
  ];

  const itemsMensuel = [
    { title: "1", titleBig: "1" },
    { title: "2", titleBig: "2" },
    { title: "3", titleBig: "3" },
    { title: "4", titleBig: "4" },
    { title: "5", titleBig: "5" },
    { title: "6", titleBig: "6" },
    { title: "7", titleBig: "7" },
    { title: "8", titleBig: "8" },
    { title: "9", titleBig: "9" },
    { title: "10", titleBig: "10" },
    { title: "11", titleBig: "11" },
    { title: "12", titleBig: "12" },
    { title: "13", titleBig: "13" },
    { title: "14", titleBig: "14" },
    { title: "15", titleBig: "15" },
    { title: "16", titleBig: "16" },
    { title: "17", titleBig: "17" },
    { title: "18", titleBig: "18" },
    { title: "19", titleBig: "19" },
    { title: "20", titleBig: "20" },
    { title: "21", titleBig: "21" },
    { title: "22", titleBig: "22" },
    { title: "23", titleBig: "23" },
    { title: "24", titleBig: "24" },
    { title: "25", titleBig: "25" },
    { title: "26", titleBig: "26" },
    { title: "27", titleBig: "27" },
    { title: "28", titleBig: "28" },
    { title: "29", titleBig: "29" },
    { title: "30", titleBig: "30" },
    { title: "31", titleBig: "31" },
  ];

  const itemsAnnuel = [
    { title: "J", titleBig: "Janvier" },
    { title: "F", titleBig: "Février" },
    { title: "M", titleBig: "Mars" },
    { title: "A", titleBig: "Avril" },
    { title: "M", titleBig: "Mai" },
    { title: "J", titleBig: "Juin" },
    { title: "J", titleBig: "Juillet" },
    { title: "A", titleBig: "Août" },
    { title: "S", titleBig: "Septembre" },
    { title: "O", titleBig: "Octobre" },
    { title: "N", titleBig: "Novembre" },
    { title: "D", titleBig: "Décembre" },
  ];

  let items = [];

  if (temporalite === "hebdomadaire") {
    items = itemsHebdomadaire;
  }
  if (temporalite === "mensuel") {
    items = itemsMensuel;
  }
  if (temporalite === "annuel") {
    items = itemsAnnuel;
  }

  const scrolltoId = (type, id) => {
    id = id + 1;
    var access = document.getElementById(type + id);

    var divParentAccess = access.parentNode;
    var divEnfantsChronoContainer = divParentAccess.getElementsByClassName("chronoItem");
    for (var i = 0; i < divEnfantsChronoContainer.length; i++) {
      divEnfantsChronoContainer[i].classList.remove("chronoItemActive");
    }
    access.classList.add("chronoItemActive");

    var offsetLeft = access.offsetLeft;
    var offsetTop = document.getElementById("chronoTimelineContainer_" + type).offsetTop;

    window.scroll({
      top: offsetTop - 40,
      left: 0,
      behavior: "smooth",
    });
    document.getElementById("chronoContainer_" + type).scrollLeft = offsetLeft - 15;
  };

  return (
    <div className="mb-5" id={"chronoTimelineContainer_step_" + temporalite}>
      <div className="chronoTimelineContainer mb-2">
        <ul className="chronoTimeline">
          {items.map((item, indexItem) => (
            <React.Fragment key={indexItem}>
              {objets.filter((item) =>
                item.detailFrequence.includes(temporalite === "annuel" ? indexItem : indexItem + 1)
              ).length ? (
                <li onClick={(e) => scrolltoId("step_" + temporalite, indexItem)}>{item.title}</li>
              ) : (
                <li className="disable">{item.title}</li>
              )}
            </React.Fragment>
          ))}
        </ul>
        <div className="chronoTimelineLine"></div>
      </div>
      <br />
      <div className="chronoContainer" id={"chronoContainer_step_" + temporalite}>
        {items.map((item, indexItem) => (
          <React.Fragment key={parseInt(indexItem + 1)}>
            {objets.filter((item) =>
              item.detailFrequence.includes(temporalite === "annuel" ? indexItem : indexItem + 1)
            ).length !== 0 && (
              <div className="chronoItem" id={"step_" + temporalite + parseInt(indexItem + 1)}>
                <div className="chronoItemTitreTemporalite">{items[indexItem].titleBig}</div>
                {objets
                  .filter((item) =>
                    item.detailFrequence.includes(
                      temporalite === "annuel" ? indexItem : indexItem + 1
                    )
                  )
                  .map((objet, indexObjet) => (
                    <div key={indexObjet}>
                      <Link to={"/orgunits/" + objet._id}>
                        <span
                          className={
                            objet.type === "Rituel" ? "chronoItemTypeRituel" : "chronoItemTypeTemps"
                          }
                        ></span>{" "}
                        {objet.nom}
                      </Link>
                    </div>
                  ))}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ComponentGovernanceChrono;
